// Layout Switch
// =============

import Cookies from 'js-cookie';
import RadioGroup from './RadioGroup';

class LayoutSwitch {
    constructor(switchSelector, targetSelector, cookieName) {
        this.cookieName = cookieName;
        this.target = document.querySelector(targetSelector);
        if (!this.target) return;

        try {
            this.switch = new RadioGroup(switchSelector, false, true);
        } catch (_) {
            return;
        }
        this.previousValue = this.switch.selectedValue;
        this.switch.addEventListener('change', (e) => {
            this.onSwitchChange(e);
        });
    }

    onSwitchChange(e) {
        const value = e.target.selectedValue;
        if (this.previousValue) this.target.classList.remove(this.previousValue);
        if (value) this.target.classList.add(value);
        this.previousValue = value;
        Cookies.set(this.cookieName, value);
    }
}

export default LayoutSwitch;
